import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
    useAddMemberMutation,
    useGetTeamQuery,
} from "../Features/teams/teamsApi";

const AddMember = ({ membarAddModal, setMemberAddModal, teamId }) => {
    const [members, setMembers] = useState([]);
    const [memberEmail, setMemberEmail] = useState("");
    const { data } = useGetTeamQuery(teamId);
    const [addMember] = useAddMemberMutation();

    const users = useSelector((state) => state?.users);

    useEffect(() => {
        if (data) {
            setMembers(data?.members);
        }
    }, [data]);

    const handlerAddMember = async (e) => {
        e.preventDefault();
        console.log(users);
        const isValid = users?.users?.users.find(
            (e) => e.email === memberEmail
        );
        const isExist = members.find((m) => m.email === memberEmail);
        if (isExist) {
            toast.error(`${memberEmail} is already member`);
        }
        if (!isValid) {
            toast.error(`${memberEmail} is not a valid user`);
        }

        if (!isExist && isValid) {
            const newId = members.length + 1;

            const updateData = {
                ...data,
                members: [
                    ...members,
                    {
                        id: newId,
                        email: memberEmail,
                    },
                ],
            };
            console.log(updateData);

            await addMember({
                id: teamId,
                data: updateData,
            });
            toast.success("added");
            setMemberAddModal(!membarAddModal);
        }
    };

    return (
        membarAddModal && (
            <>
                <div
                    className="fixed w-full h-full inset-0 z-10 bg-black/50 cursor-pointer"
                    onClick={() => setMemberAddModal(!membarAddModal)}
                ></div>
                <div className="rounded w-[400px] lg:w-[600px] space-y-8 bg-white p-10 absolute top-1/2 left-1/2 z-20 -translate-x-1/2 -translate-y-1/2">
                    <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                        Add Member in Team
                    </h2>
                    <form
                        className="mt-8 space-y-6"
                        onSubmit={handlerAddMember}
                    >
                        <div className="rounded-md shadow-sm -space-y-px">
                            <div>
                                <label htmlFor="email" className="sr-only">
                                    To
                                </label>
                                <input
                                    id="email"
                                    name="to"
                                    type="email"
                                    required
                                    className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                                    placeholder="Email"
                                    onChange={(e) =>
                                        setMemberEmail(e.target.value)
                                    }
                                />
                            </div>
                        </div>

                        <div>
                            <button
                                type="submit"
                                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
                            >
                                Add
                            </button>
                        </div>
                    </form>
                </div>
            </>
        )
    );
};

export default AddMember;
